export class AnalyticsEvent {

    public name: string;
    public source: string;
    public os: string;
    public parameters: any;

    constructor() {
    }
}
